import type { FaireProductEntity } from "../../entity_types/product";

export const p_kdspx6vu84: FaireProductEntity = {
  token: "p_kdspx6vu84",
  type: "product",
  name: "Solid 3/4 Sleeve Boxy Button-Down Cardigan",
  brandToken: "b_b5qvtl6s4w",
  brandName: "PRETTY BASH",
  imageUrl:
    "https://cdn.faire.com/fastly/df41e593c60f94fc192f8d008b7c146413786f43141aec9ffd242b8cff98372d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3918895b9d8d9d2e2d471fd9282442e54b212b915894ec20d667340fd60d469c.jpeg",
    "https://cdn.faire.com/fastly/c0c6033172e25dee92db8fbfd4845fadba205c9eda0f130def8c27846364c7ce.jpeg",
    "https://cdn.faire.com/fastly/7b96a8c96c630d67fcea74a291497fc866a0453dc874bbdab6cf71936d443b4e.jpeg",
    "https://cdn.faire.com/fastly/fe653f4a9ce629182880128c7f7cd72346e1f3c9a6a6d2ae68e16bddac60acf6.jpeg",
    "https://cdn.faire.com/fastly/2150e2040ad93d2918b171210e609b4e007af5cf6b42075ff0fdcfaf5d3f0034.jpeg",
    "https://cdn.faire.com/fastly/467df60af9260c2acb52416a05a091536180ab0a60dc7829c954f3a74bb11501.jpeg",
    "https://cdn.faire.com/fastly/fc834676c5c3854aec7f25f8c7bf634822cd2c16d8c0aab4be080203f6af400d.jpeg",
    "https://cdn.faire.com/fastly/cce4778fd9ba016d37dae754848abb4bb1508e46f6ab0a951c8ec814dbcd2f96.jpeg",
    "https://cdn.faire.com/fastly/b6bf5f75847c33ee9b636b563c0346c08b7d0147a8545dddc2f35659b846bee8.jpeg",
    "https://cdn.faire.com/fastly/1cedee62f16ca43787a5aa4b3eb943c919ad5d7e8d7531c1fb5049407522bdb8.jpeg",
    "https://cdn.faire.com/fastly/12090559ab6fc4bba4278b6b63fd4fd3300d90fe3ecf37eca58c7e61ab046493.jpeg",
    "https://cdn.faire.com/fastly/7643ec383d6137dc4c4977c332318c4c6714783c8fece155b770a31615da416e.jpeg",
    "https://cdn.faire.com/fastly/d37e9e953201f03dc959c0f5d17a45291ffc2cba390f99d668eaca3f3c8097ce.jpeg",
    "https://cdn.faire.com/fastly/e1ac703c6e4a3d08d3cbe1512b21ecb71db20fde14cda34637f72dd48c603823.jpeg",
    "https://cdn.faire.com/fastly/829ac21986ce119481f87aa89a524f5a383c0162f59004682daf4db140d53ecc.jpeg",
    "https://cdn.faire.com/fastly/ae76831ee724726a4a31294e09ad41ec7169a71597213a074bd9b922a36cfd58.jpeg",
    "https://cdn.faire.com/fastly/0c09673b49c565bc17542dd2d992799a91badac093d57b23545d7331642ebde0.jpeg",
    "https://cdn.faire.com/fastly/7557db7c7e53275b13b6b52598f933b67cc9c4922de44e88572412fcff81e340.jpeg",
    "https://cdn.faire.com/fastly/54b544d9459576e0f520b4d29d2d7aa32cb90a066d83d9ac3acce153af5b16d4.png",
  ],
  priceDollars: 16.68,
  description:
    "Meet your new go-to layer! This cardigan brings effortless cool to any outfit with its relaxed, modern silhouette and perfectly proportioned 3/4 sleeves, ideal for those in-between seasons when you can't quite commit to a full coat. The button-down design makes getting dressed a breeze, while the soft knit fabric feels as good as it looks. Throw it over your favorite jeans for casual vibes or layer it with a dress for instant polish. Simple, versatile, and endlessly wearable. Acrylic/Polyester/Poly\n\nSize info:\nSee size chart for approximate measurements.\n\nSeason: Fall, Winter, Spring\n\n",
  tags: [],
  msrpDollars: 33.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:58.288Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
